
  <div class="border-0 px-4 py-1 scroll-container" ref="manage_questions">
    <NavigationBackButton/>
    <div class="card-header card-header-primary shadow rounded-lg mt-3">
      <div class="nav-tabs-navigation">
        <div class="nav-tabs-wrapper">
          <ul class="nav nav-tabs" data-tabs="tabs">
            <li class="rounded-lg me-2 nav-item">
              <a class="text-dark-blue text-decoration-none fs-5 fw-bold nav-link" href="#profile" data-toggle="tab">
                <span><i class="bi bi-question-circle fs-4 me-2"></i></span>Manage Questions
              </a>
            </li>
          </ul>
          <div class="d-flex justify-content-end">
            <button v-if="question_list.length > 0" class="btn btn-primary-dark btn-sm text-xxs shadow"
            data-bs-toggle="modal" data-bs-target="#create_questions_modal" @click="open_create_questions_modal">
              Create Questions
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="glassy-table rounded-lg border-0 shadow mt-2">
      <div class="d-flex flex-row mt-2 ms-4 mt-4 justify-content-end">   
        <button v-if="question_list.length > 0" class="d-none btn btn-primary-dark btn-sm text-xxs shadow ms-3"
          @click="assign_questions_to_section">
          Assign Selections
        </button>
        <div class="me-md-3" v-if="question_list.length === 0">
          <button class="btn btn-primary-dark btn-sm shadow text-xxs mt-3" data-bs-toggle="modal"
            data-bs-target="#create_questions_modal" @click="open_create_questions_modal">
            Create Your First Question
          </button>
        </div>
      </div>
      <div class="">
        <div class=" rounded-lg p-3 table-responsive text-xs">
          <table class="table table-hover" id="question_management_table">
            <thead class="custom-header">
              <tr>
                <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">#</th>
                <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Question</th>
                <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Type</th>
                <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Choices</th>
                <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in table_safe_question_list" :key="row.id">
                <td class="text-xxs text-start">{{ index + 1 }}</td>
                <td class="text-xxs text-start">{{ row.question }}</td>
                <td class="text-xxs text-start">{{ row.type }}</td>
                <td class="text-xxs text-start">{{ row.choices }}</td>
                <td class="d-flex flex-nowrap gap-2 align-items-center">
                  <input type="checkbox" :checked="selected_questions.includes(row.id)"
                    @change="toggle_selection(row.id)" class="form-check-input me-2 d-none" />
                  <button class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark me-2"
                    data-bs-toggle="modal" data-bs-target="#edit_question_modal" @click="open_edit_modal(row, index)">
                    Edit
                  </button>
                  <button class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark me-2"
                    data-bs-toggle="modal" data-bs-target="#manage_dependent_questions_modal"
                    @click="open_manage_dependent_modal(row.id)">
                    {{ row.dependent_questions && row.dependent_questions.length > 0 ? `Dependent
                    (${row.dependent_questions.length})` : 'Add Dependent' }}
                  </button>
                  <button class="btn btn-sm btn-danger d-none" @click="delete_question(row.id)">
                    Delete
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Edit Question Modal -->
    <teleport to="body">
      <div id="edit_question_modal" class="modal fade show" tabindex="-1" aria-labelledby="edit_question_label"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
            <div class="modal-header border-bottom-0 cute-header shadow-lg">
              <p class="modal-title text-white text-xxs">Edit Question</p>
              <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <!-- Edit Question Form -->
              <div class="modal-form-group form-group mb-3">
                <label for="question" class="modal-form-label form-label text-xxs"><span
                    class="text-danger fs-6">*</span>Question:</label>
                <input type="text" v-model="current_edit_question.question"
                  class="modal-form-control form-control text-xxs rounded-3 p-2 shadow-sm mb-3"
                  placeholder="Question here" />
                <label for="question_number" class="modal-form-label form-label text-xxs"><span
                    class="text-danger fs-6">*</span>Question Number:</label>
                <input type="text" v-model="current_edit_question.question_number"
                  class="modal-form-control form-control text-xxs rounded-3 p-2 shadow-sm mb-3"
                  placeholder="Question here" />
                <label for="question_type_name" class="modal-form-label form-label text-xxs"><span
                    class="text-danger fs-6">*</span>Question Type:</label>
                <select v-model="current_edit_question.question_type"
                  class="modal-form-select form-select text-xxs rounded-3 p-2 shadow-sm mb-3"
                  @change="handle_question_type_change_for_edit(current_edit_question)">
                  <option value="" disabled>Select Type</option>
                  <option v-for="type in question_types" :key="type.id" :value="type.id">
                    {{ type.formatted_type }}
                  </option>
                </select>
              </div>
  
              <!-- Dynamic Options Section -->
              <div v-if="current_edit_question.show_option_inputs" class="mt-3">
                <div class="row mb-2">
                  <div class="col-12 d-flex justify-content-between align-items-center">
                    <label class="modal-form-label form-label text-xxs mb-0">Options</label>
                    <button @click="add_option_input(current_edit_question)"
                      class="btn btn-primary btn-sm rounded-3 fw-bold text-xxs shadow text-white me-2">
                      <i class="fas fa-plus"></i>
                    </button>
                  </div>
                </div>
  
                <div v-for="(option, option_index) in current_edit_question.option_inputs" :key="option_index"
                  class="mb-3 position-relative">
                  <input v-model="current_edit_question.option_inputs[option_index]" type="text"
                    class="modal-form-control form-control text-xxs rounded-3 p-2 shadow-sm"
                    :placeholder="'Option ' + (option_index + 1)" />
                  <span @click="remove_option_input(current_edit_question, option_index)"
                    class="remove-option-icon position-absolute end-0 top-50 translate-middle-y me-2"
                    v-if="current_edit_question.option_inputs && current_edit_question.option_inputs.length > 2">
                    <i class="fas fa-times small-icon"></i>
                  </span>
                </div>
              </div>
  
              <!-- Dependent Questions Section -->
              <div class="mt-4 border-top pt-3">
                <div v-for="(dep_question, dep_index) in current_edit_question.dependant_questions" :key="dep_index"
                  class="mb-4 p-3 border rounded">
                  <div class="d-flex justify-content-between align-items-center mb-2">
                    <h6 class="mb-0 text-xs fw-bold">
                      Dependent Question {{ dep_index + 1 }}
                    </h6>

                    <button
                      type="button"
                      class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow"
                      @click="remove_dependent_question(current_edit_question, dep_index)"
                    >
                      Remove
                    </button>
                  </div>
  
                  <div class="row mb-3">
                    <div class="col-md-6">
                      <label class="form-label text-xs">Question Text<span class="text-danger fs-6">*</span></label>
                      <input v-model="dep_question.question_text" type="text"
                        class="form-control text-xxs rounded-small shadow-sm"
                        placeholder="e.g. What is your first name?" />
                    </div>
                    <div class="col-md-3">
                      <label class="form-label text-xs">Trigger Condition<span class="text-danger fs-6">*</span></label>
                      <!-- FIXED: Use current_edit_question.option_inputs instead of dep_question.parent_options -->
                      <select v-if="current_edit_question.show_option_inputs && current_edit_question.option_inputs && current_edit_question.option_inputs.length > 0"
                        v-model="dep_question.trigger_condition" class="form-control text-xxs rounded-small shadow-sm">
                        <option value="" disabled>Select a trigger condition</option>
                        <option v-for="(option, opt_index) in current_edit_question.option_inputs" :key="opt_index" :value="option">
                          {{ option }}
                        </option>
                      </select>
                      <input v-else v-model="dep_question.trigger_condition" type="text"
                        class="form-control text-xxs rounded-small shadow-sm" placeholder="Trigger value" />
                    </div>
                    <div class="col-md-3">
                      <label class="form-label text-xs">Mandatory</label>
                      <select v-model="dep_question.is_mandatory" class="form-select text-xxs rounded-small shadow-sm">
                        <option :value="true">Yes</option>
                        <option :value="false">No</option>
                      </select>
                    </div>
                  </div>
  
                  <!-- Question type, number -->
                  <div class="row mb-3">
                    <div class="col-md-4">
                      <label class="form-label text-xs">Question Type<span class="text-danger fs-6">*</span></label>
                      <select v-model="dep_question.question_type_id" class="form-select text-xxs rounded-small shadow-sm"
                        @change="handle_dependent_question_type_change(dep_question)">
                        <option value="" disabled hidden>Select Type</option>
                        <option v-for="type in question_types" :key="type.id" :value="type.id">
                          {{ type.formatted_type }}
                        </option>
                      </select>
                    </div>
                    <div class="col-md-4">
                      <label class="form-label text-xs">Question Number</label>
                      <input v-model="dep_question.question_number" type="text"
                        class="form-control text-xxs rounded-small shadow-sm" placeholder="e.g. 1.1" />
                    </div>
                  </div>
  
                  <!-- Options for select-type dependent questions -->
                  <div v-if="dep_question.show_option_inputs" class="mt-3">
                    <div class="row mb-2">
                      <div class="col-12 d-flex justify-content-between align-items-center">
                        <label class="form-label text-xs mb-0">Options</label>
                        <div>
                          <button type="button" @click="add_dependent_option(dep_question)"
                            class="btn btn-primary-dark btn-sm rounded-small fw-bold text-xxs shadow text-white me-2">
                            <i class="fas fa-plus"></i>
                          </button>
                        </div>
                      </div>
                    </div>
  
                    <div v-for="(option, option_index) in dep_question.options" :key="option_index" class="row mb-3">
                      <div class="col-10">
                        <input v-model="dep_question.options[option_index].choice" type="text"
                          class="form-control text-xs rounded-small p-2 shadow-sm" placeholder="Option value" />
                      </div>
                      <div class="col-2">
                        <button type="button" @click="remove_dependent_option(dep_question, option_index)"
                          class="btn btn-danger btn-sm rounded-small fw-bold text-xxs shadow">
                          <i class="fas fa-trash"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="d-flex justify-content-between align-items-center mb-3">
                  <h6 class="mb-0 text-xs">Dependent Questions</h6>
                  <button type="button" class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow"
                    @click="add_dependent_question(current_edit_question)">
                    Add Dependent Question
                  </button>
                </div>
              </div>
            </div>
            <div class="modal-footer border-0 p-2 d-flex justify-content-end">
              <button type="button" class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
                @click="save_edited_question">
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </teleport>

    <!-- Dependent Questions Modal -->
  <teleport to="body">
    <div id="dependent_questions_modal" class="modal fade show" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
          <div class="modal-header border-bottom-0 cute-header shadow-lg">
            <p class="modal-title text-white text-xxs">Dependent Questions</p>
            <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"
              @click="close_dependent_modal"></button>
          </div>
          <div class="modal-body">
            <div v-if="current_dependent_questions.length === 0" class="text-center py-4">
              <p class="text-muted">No dependent questions found</p>
            </div>
            <div v-else class="table-responsive">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th class="text-xxs">#</th>
                    <th class="text-xxs">Question</th>
                    <th class="text-xxs">Type</th>
                    <th class="text-xxs">Trigger Condition</th>
                    <th class="text-xxs">Mandatory</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(question, index) in current_dependent_questions" :key="index">
                    <td class="text-xxs">{{ index + 1 }}</td>
                    <td class="text-xxs">{{ question.question_text }}</td>
                    <td class="text-xxs">{{ question.type }}</td>
                    <td class="text-xxs">{{ question.trigger_condition }}</td>
                    <td class="text-xxs">{{ question.is_mandatory }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </teleport>

    <!-- Create Questions Modal -->
    <teleport to="body">
    <teleport to="body">
    <div class="modal fade show" id="create_questions_modal" tabindex="-1" aria-labelledby="create_question_label"
      aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
          <div class="modal-header border-bottom-0 cute-header shadow-lg">
            <p class="modal-title text-white text-xxs">Create Questions</p>
            <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"
              @click="close_create_modal"></button>
          </div>
          <div class="modal-body d-flex flex-column flex-grow-1 overflow-auto">
            <div class="flex-grow-1 overflow-auto">
              <div v-for="(form, index) in question_forms" :key="form.id" class="card rounded-3 border-top-0 p-2 mb-3">
                <div class="card-header bg-white border-0 d-flex justify-content-between align-items-center">
                  <span>Question {{ index + 1 }}</span>
                  <div>
                    <button type="button" class="btn btn-primary-dark btn-sm rounded-3 text-xxs shadow text-white me-2"
                      @click="add_question_form">
                      <i class="fas fa-plus"></i>
                    </button>
                    <button type="button" class="btn btn-primary-dark btn-sm rounded-3 text-xxs shadow text-white"
                      @click="remove_question_form(index)" :disabled="question_forms.length <= 1">
                      <i class="fas fa-trash"></i>
                    </button>
                  </div>
                </div>
                <div class="card-body">
                  <div class="mb-3">
                    <label class="modal-form-label form-label text-xxs">
                      Question Text <span class="text-danger fs-6">*</span>
                    </label>
                    <input v-model="form.question" type="text"
                      class="modal-form-control form-control text-xxs rounded-3 p-3 shadow-sm" required
                      placeholder="e.g Are you a director of a company?" />
                  </div>

                  <div class="mb-3">
                    <label class="modal-form-label form-label text-xxs">
                      Question Type <span class="text-danger fs-6">*</span>
                    </label>
                    <select v-model="form.question_type"
                      class="modal-form-select form-select text-xxs rounded-3 p-2 shadow-sm" required
                      @change="handle_question_type_change_for_form(form)">
                      <option value="" disabled selected>Select Type</option>
                      <option v-for="type in question_types" :key="type.id" :value="type.id">
                        {{ type.formatted_type }}
                      </option>
                    </select>
                  </div>
                  <div class="mb-3">
                    <label class="modal-form-label form-label text-xxs">Is question mandatory?</label>
                    <select v-model="form.is_mandatory"
                      class="modal-form-select form-select text-xxs rounded-3 p-2 shadow-sm" required>
                      <option value="" disabled selected>Select Option</option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </select>
                  </div>

                  <!-- Dynamic Options Section -->
                  <div v-if="form.show_option_inputs" class="mt-3">
                    <div class="d-flex justify-content-between align-items-center mb-2">
                      <label class="form-label fw-bold small mb-0">Options</label>
                      <button @click="add_option_input(form)"
                        class="btn btn-primary btn-sm rounded-3 text-xxs shadow me-2">
                        <i class="fas fa-plus"></i>
                      </button>
                    </div>

                    <div v-for="(option, option_index) in form.option_inputs" :key="option_index"
                      class="mb-3 position-relative">
                      <input v-model="form.option_inputs[option_index]" type="text"
                        class="modal-form-control form-control text-xxs rounded-3 p-2 shadow-sm"
                        :placeholder="'Option ' + (option_index + 1)" />
                      <span @click="remove_option_input(form, option_index)"
                        class="remove-option-icon position-absolute end-0 top-50 translate-middle-y me-2"
                        v-if="form.option_inputs.length > 2">
                        <i class="fas fa-times small-icon"></i>
                      </span>
                    </div>
                  </div>

                  <!-- Dependent Questions Section -->
                  <div class="mt-4 border-top pt-3">
                    <div v-for="(dep_question, dep_index) in form.dependant_questions" :key="dep_index"
                      class="mb-4 p-3 border rounded">
                      <div class="d-flex justify-content-between align-items-center mb-2">
                        <h6 class="mb-0 text-xs fw-bold">
                          Dependent Question {{ dep_index + 1 }}
                        </h6>

                        <button
                          type="button"
                          class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow"
                          @click="remove_dependent_question(form, dep_index)"
                        >
                          Remove
                        </button>
                      </div>

                      <div class="row mb-3">
                        <div class="col-md-6">
                          <label class="form-label text-xs">Question Text<span class="text-danger fs-6">*</span></label>
                          <input v-model="dep_question.question_text" type="text"
                            class="form-control text-xxs rounded-small shadow-sm"
                            placeholder="e.g. What is your first name?" />
                        </div>
                        <div class="col-md-3">
                          <label class="form-label text-xs">Trigger Condition<span
                              class="text-danger fs-6">*</span></label>
                          <!-- Updated Trigger Condition Input -->
                          <select v-if="form.show_option_inputs && form.option_inputs.length > 0"
                            v-model="dep_question.trigger_condition"
                            class="form-control text-xxs rounded-small shadow-sm">
                            <option v-for="(option, opt_index) in form.option_inputs" :key="opt_index" :value="option">
                              {{ option }}
                            </option>
                          </select>
                          <input v-else v-model="dep_question.trigger_condition" type="text"
                            class="form-control text-xxs rounded-small shadow-sm" placeholder="Trigger value" />
                        </div>
                        <div class="col-md-3">
                          <label class="form-label text-xs">Mandatory</label>
                          <select v-model="dep_question.is_mandatory"
                            class="form-select text-xxs rounded-small shadow-sm">
                            <option :value="true">Yes</option>
                            <option :value="false">No</option>
                          </select>
                        </div>
                      </div>

                      <!-- Question type, number-->
                      <div class="row mb-3">
                        <div class="col-md-4">
                          <label class="form-label text-xs">Question Type<span class="text-danger fs-6">*</span></label>
                          <select v-model="dep_question.question_type_id"
                            class="form-select text-xxs rounded-small shadow-sm"
                            @change="handle_dependent_question_type_change(dep_question)">
                            <option value="" disabled hidden>Select Type</option>
                            <option v-for="type in question_types" :key="type.id" :value="type.id">
                              {{ type.formatted_type }}
                            </option>
                          </select>
                        </div>
                        <div class="col-md-4">
                          <label class="form-label text-xs">Question Number</label>
                          <input v-model="dep_question.question_number" type="text"
                            class="form-control text-xxs rounded-small shadow-sm" placeholder="e.g. 1.1" />
                        </div>
                      </div>

                      <!-- Options for select-type dependent questions -->
                      <div v-if="dep_question.show_option_inputs" class="mt-3">
                        <div class="row mb-2">
                          <div class="col-12 d-flex justify-content-between align-items-center">
                            <label class="form-label text-xs mb-0">Options</label>
                            <div>
                              <button type="button" @click="add_dependent_option(dep_question)"
                                class="btn btn-primary-dark btn-sm rounded-small fw-bold text-xxs shadow text-white me-2">
                                <i class="fas fa-plus"></i>
                              </button>
                            </div>
                          </div>
                        </div>

                        <div v-for="(option, option_index) in dep_question.options" :key="option_index"
                          class="row mb-3">
                          <div class="col-10">
                            <input v-model="dep_question.options[option_index].choice" type="text"
                              class="form-control text-xs rounded-small p-2 shadow-sm" placeholder="Option value" />
                          </div>
                          <div class="col-2">
                            <button type="button" @click="remove_dependent_option(dep_question, option_index)"
                              class="btn btn-danger btn-sm rounded-small fw-bold text-xxs shadow">
                              <i class="fas fa-trash"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="d-flex justify-content-between align-items-center mb-3">
                      <h6 class="mb-0 text-xs">Dependent Questions</h6>
                      <button type="button" class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow"
                        @click="add_dependent_question(form)">
                        Add Dependent Question
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="mt-3 text-end">
              <button type="button" class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow px-4 py-2"
                @click="save_all_questions">
                {{ question_forms.length > 1 ? 'Save All Questions' : 'Save Question' }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    </teleport>
    </teleport>

    <!-- Manage Dependent Questions Modal -->
    <teleport to="body">
      <div class="modal fade" id="manage_dependent_questions_modal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header custom-header">
              <h5 class="modal-title text-uppercase text-xxs font-weight-bolder text-white opacity-7">
                Manage Dependent Questions
              </h5>
              <button type="button" class="btn-close shadow-none" data-bs-dismiss="modal" aria-label="Close"
                @click="close_manage_dependent_modal"></button>
            </div>

            <div class="modal-body py-3">
              <!-- Section 1: Add New Dependent Question -->
              <div class="card mb-4">
                <div class="card-header">
                  <p class="mb-0 fw-bold text-x">
                    {{ is_editing_dependent ? 'Edit Dependent Question' : 'Add New Dependent Question' }}
                  </p>
                </div>
                <div class="card-body">
                  <p class="text-xxs text-muted mb-3">
                    {{ is_editing_dependent
                    ? 'Update your dependent question details below and click Save when done.'
                    : 'Dependent questions appear when certain conditions are met in the parent question.'
                    }}
                  </p>

                  <div class="row mb-3">
                    <div class="col-md-12">
                      <label for="dependentQuestionText" class="form-label text-xxs">Question Text</label>
                      <input type="text" class="form-control text-xxs" id="dependentQuestionText"
                        v-model="new_dependent_question.question_text" placeholder="E.g. Please specify your framework" />
                    </div>
                  </div>

                  <div class="row mb-3">
                    <div class="col-md-6">
                      <label for="dependentQuestionType" class="form-label text-xxs">Question Type</label>
                      <select class="form-select text-xxs"
                              id="dependentQuestionType"
                              v-model="new_dependent_question.question_type_id"
                              @change="handle_dependent_question_type_change(new_dependent_question)">
                        <option value="">Select a question type</option>
                        <option v-for="type in question_types" :value="type.id">
                          {{ type.formatted_type }}
                        </option>
                      </select>

                    </div>
                    <div class="col-md-6">
                      <label class="form-label text-xs">Trigger Condition<span class="text-danger fs-6">*</span></label>
                      <select v-if="parent_question_options && parent_question_options.length > 0"
                        v-model="new_dependent_question.trigger_condition"
                        class="form-control text-xxs rounded-small shadow-sm" required>
                        <option value="" disabled>Select a trigger condition</option>
                        <option v-for="(option, opt_index) in parent_question_options" :key="opt_index" :value="option">
                          {{ option }}
                        </option>
                      </select>
                      <div v-else class="text-danger text-xxs">
                        This parent question doesn't have any choices to use as trigger conditions.
                      </div>
                    </div>
                  </div>

                  <div class="row mb-3">
                    <div class="col-md-4">
                      <label for="dependentQuestionNumber" class="form-label text-xxs">Question Number</label>
                      <input type="text" class="form-control text-xxs" id="dependentQuestionNumber"
                        v-model="new_dependent_question.question_number" placeholder="E.g. 1.1" />
                    </div>
                  </div>

                  <!-- Dynamic Options for Dependent Question -->
                  <div v-if="new_dependent_question.show_option_inputs" class="mt-3">

                    <div class="d-flex justify-content-between align-items-center mb-2">
                      <label class="form-label text-xxs fw-bold mb-0">Options</label>

                      <button type="button"
                        class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow"
                        @click="add_dependent_option(new_dependent_question)">
                        <i class="fas fa-plus"></i>
                      </button>
                    </div>

                    <div v-for="(opt, i) in new_dependent_question.options" :key="i"
                      class="mb-2 position-relative">
                      <input type="text"
                        class="form-control text-xxs rounded-small shadow-sm"
                        v-model="new_dependent_question.options[i].choice"
                        :placeholder="'Option ' + (i + 1)" />

                      <button
                        v-if="new_dependent_question.options.length > 2"
                        class="btn btn-danger btn-sm rounded-small position-absolute end-0 top-50 translate-middle-y me-1"
                        @click="remove_dependent_option(new_dependent_question, i)">
                        <i class="fas fa-times"></i>
                      </button>
                    </div>

                  </div>


                  <div class="row mb-3">
                    <div class="col-md-12">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" id="dependentMandatory"
                          v-model="new_dependent_question.is_mandatory">
                        <label class="form-check-label text-xxs" for="dependentMandatory">
                          Mandatory Question
                        </label>
                      </div>
                    </div>
                  </div>

                  <div class="mt-3">
                    <button class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow-sm text-dark"
                      @click="is_editing_dependent ? update_dependent_question() : assign_dependent_question()" :disabled="(!new_dependent_question.question_text || !new_dependent_question.question_type_id || !new_dependent_question.trigger_condition) || 
                  (is_editing_dependent ? update_dependent_loading : dependent_loading)">
                      <span v-if="is_editing_dependent ? update_dependent_loading : dependent_loading"
                        class="spinner-border spinner-border-sm me-1"></span>
                      {{ is_editing_dependent ? 'Save' : 'Add' }}
                    </button>
                    <button v-if="is_editing_dependent"
                      class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow-sm text-dark ms-2"
                      @click="cancel_edit_dependent">
                      Cancel
                    </button>
                  </div>
                </div>
              </div>

              <!-- Section 2: Current Dependent Questions -->
              <div class="card">
                <div class="card-header">
                  <h6 class="mb-0 fw-bold text-x">Current Dependent Questions</h6>
                </div>
                <div class="card-body">
                  <div class="table-responsive">
                    <table class="table table-hover w-100">
                      <thead class="custom-header">
                        <tr>
                          <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start">
                            Question
                          </th>
                          <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start">
                            Trigger Condition
                          </th>
                          <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start">
                            Actions
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="question in current_dependent_questions" :key="question.id">
                          <td class="text-xxs text-start">
                            {{ question.question_text }}
                          </td>
                          <td class="text-xxs text-start">
                            {{ question.trigger_condition }}
                          </td>
                          <td class="text-xxs text-start">
                            <button class="btn btn-primary-dark btn-sm px-3 shadow-sm text-xxs me-2"
                              @click="edit_dependent_question(question)" :disabled="question.is_loading">
                              <span v-if="question.is_loading" class="spinner-border spinner-border-sm me-1"></span>
                              Edit
                            </button>
                            <button class="btn btn-primary-dark btn-sm px-3 shadow-sm text-xxs"
                              @click="unassign_dependent_question(question)" :disabled="question.is_loading">
                              <span v-if="question.is_loading" class="spinner-border spinner-border-sm me-1"></span>
                              Remove
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div v-if="current_dependent_questions.length === 0" class="text-center py-4">
                      <p class="text-muted text-xxs">No dependent questions found</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </teleport>
  </div>
